import React from "react"

import Board_Manager from "../../../../../gd-modules/tasks-view/board/managers/manager"
import FieldProto from "../../../../proto/field-proto"
import Board_AggregateShell from "../../../../../gd-modules/tasks-view/board/components/aggregate/aggregate-shell"

type Props = {
    className       : string

    manager         : Board_Manager
    field           : FieldProto

    calculatedData  : {
        own             : {
            value   : number
        }
        children        : {
            value   : number
        }
        total           : {
            value   : number
        }

        hasOwnValue     : boolean
        hasChildren     : boolean
    }
}

// const debug = "FieldProgress_BoardAggregate"
const debug = false

export default function FieldProgress_BoardAggregate(props: Props) {

    let value = props.calculatedData?.total.value
    const isValid = !_.isNil(value) && !_.isNaN(value)

    debug && console.log(debug, 'render', isValid, value, props.calculatedData)

    let valueLabel
    let progressLine
    let progressClasses
    if (isValid) {
        value           = Math.floor(value)
        const excess    = value > 100
        progressLine    = excess ? Math.floor(100 * (100 / value)) : value

        progressClasses = Classes("ui5-progress in-ui5-field", {
            'excess-v2': excess,
        })

        valueLabel = '{0}%'.f(value)
    }

    const showLine = isValid && !!value
    const classes = Classes("max-w-100", props.className, {
        'w-100p'        : showLine,
        'show-on-hover' : !showLine
    })

    return (
        <Board_AggregateShell
            className   = {classes}
            manager     = {props.manager}
            hint        = {valueLabel}
        >
            {!showLine &&
                <div className="flex-row-left-center">
                    <div className={Classes("ui5-ico-12 m-r-5 m-t-1", props.field.icon)}/>
                </div>}

            {showLine &&
                <div className={progressClasses}>
                    <div className="progress-bg">
                        <div className="progress-line" style={{width: '{0}%'.f(progressLine)}}/>
                    </div>

                    <div className="progress-label ui5-txt-less-important-small percentage txt-truncate">
                        {valueLabel}
                    </div>
                </div>}
        </Board_AggregateShell>
    )
}
